module.exports = __webpack_public_path__ + "img/ai13.a7d517ff.png";